var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"financial-institution-list-item"},[_c('div',{staticClass:"meta"},[_c('router-link',{staticClass:"name",attrs:{"to":_vm.route}},[_vm._v(_vm._s(_vm.name))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }